'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var star = require('./star-dac11136.js');
require('./device.context-f96381a3.js');
var device_context_hooks = require('./device.context.hooks-0223e9f1.js');
require('./mobile-detect-2421ba00.js');

var StyledIcon = styled__default(star.Star)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  margin-right: ", ";\n  color: ", ";\n  opacity: ", ";\n  cursor: ", ";\n"], ["\n  margin-right: ", ";\n  color: ", ";\n  opacity: ", ";\n  cursor: ", ";\n"])), function (_a) {
    var last = _a.last;
    return (last ? '0' : '16px');
}, function (_a) {
    var active = _a.active, isHover = _a.isHover, theme = _a.theme;
    return (active || isHover ? theme.colors.admin.orangeAlt2 : theme.colors.greys.adminGreyMedium);
}, function (_a) {
    var isHover = _a.isHover;
    return (isHover ? '50%' : 100);
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'cursor' : 'pointer');
});
var Wrapper = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var Rating = function (_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, max = _a.max, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'md' : _d, iconStyling = _a.iconStyling, onChange = _a.onChange, rest = tslib_es6.__rest(_a, ["value", "max", "disabled", "size", "iconStyling", "onChange"]);
    var values = React.useMemo(function () { return (Array(max).fill(undefined).map(function (_, index) { return index + 1; })); }, [max]);
    var isMobile = device_context_hooks.useIsMobileView();
    var onIconClick = React.useCallback(function (selected) { return function () {
        if (!disabled && onChange) {
            onChange(selected);
        }
    }; }, [disabled, onChange]);
    var _e = tslib_es6.__read(React.useState(0), 2), hover = _e[0], setHover = _e[1];
    var onHover = React.useCallback(function (hoverValue) { return function () {
        if (!isMobile) {
            setHover(hoverValue);
        }
    }; }, [setHover, isMobile]);
    return (React__default.createElement(Wrapper, tslib_es6.__assign({}, rest, { "data-testid": "rating-container" }), values.map(function (current) { return (React__default.createElement(StyledIcon, { id: "star-" + current, dataTestId: "star-" + current, key: current, size: size, active: current <= value, disabled: disabled, onClick: onIconClick(current), onMouseOver: onHover(current), onMouseOut: onHover(0), isHover: current <= hover, last: current === max, styling: iconStyling })); })));
};
var templateObject_1, templateObject_2;

exports.Rating = Rating;
